export default "__VITE_ASSET__rqS9QxOY__"